import { render, staticRenderFns } from "./holidayDetail.vue?vue&type=template&id=3fcd8c35&scoped=true&"
import script from "./holidayDetail.vue?vue&type=script&lang=js&"
export * from "./holidayDetail.vue?vue&type=script&lang=js&"
import style0 from "./holidayDetail.vue?vue&type=style&index=0&id=3fcd8c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd8c35",
  null
  
)

export default component.exports